import Typography from '@mui/material/Typography';
import { Button, CTARoot, EbookRoot, HeaderRoot, ImageRoot } from './styled';
import ImageHero from '../../../images/ebook_menopausa.webp';
import { ReactComponent as CTAIcon } from '../../../images/report.svg';
import { useCreateConversion } from '../../../shared/hooks/useCrateConversion';

export default function Ebook() {
  const { createConvertion } = useCreateConversion();
  const onDownload = () => {
    const conversionIdentifier = 'minha_conta_download_ebook_menopausa';
    createConvertion({ conversionIdentifier });
  };
  const handleClick = () => {
    onDownload();
  };
  return (
    <EbookRoot>
      <HeaderRoot>
        <Typography variant="h4" sx={{ marginBottom: 2 }}>
          E-book gratuito e exclusivo!
        </Typography>
        <Typography>
          Uma cartilha completa sobre as diferentes fases da menopausa e as condições que envolvem essa nova etapa de vida.
        </Typography>

        <CTARoot sx={{ marginTop: 2, display: { xs: 'none', md: 'block' } }}>
          <Button
            href="https://documentos-oya.s3.us-east-2.amazonaws.com/Ebook-Menopausa.pdf"
            target="_blank"
            color="primary"
            onClick={() => handleClick()}
          >
            <CTAIcon />
            <span>Baixar e-book grátis</span>
          </Button>
        </CTARoot>
      </HeaderRoot>

      <ImageRoot>
        <img src={ImageHero} />

        <CTARoot sx={{ marginTop: 2, display: { xs: 'flex', md: 'none' } }}>
          <Button
            href="https://documentos-oya.s3.us-east-2.amazonaws.com/Ebook-Menopausa.pdf"
            target="_blank"
            color="primary"
            onClick={() => handleClick()}
          >
            <CTAIcon />
            <span>Baixar e-book grátis</span>
          </Button>
        </CTARoot>
      </ImageRoot>
    </EbookRoot>
  );
}
